import type { FC, ReactNode } from 'react';

import { FeatureFlagClientProvider } from './feature-flag-client-provider';
import { getFeatureFlags } from './get-feature-flags.action';

interface FeatureFlagProviderProps {
  children: ReactNode;
}

export const FeatureFlagProvider: FC<FeatureFlagProviderProps> = async ({ children }) => {
  const featuresEnabled = await getFeatureFlags();

  return <FeatureFlagClientProvider featuresEnabled={featuresEnabled}>{children}</FeatureFlagClientProvider>;
};

export { FeatureFlag, useFeatureFlags } from './feature-flag-client-provider';
